import React from "react";
import styles from "../stylesheets/styles.scss";

export const Modal: React.FC<{text:string}> = ({text}) => {
  return <div className={styles.modal} >
    <span className={styles.text} >{text}</span>
  </div>;
};
